import { Component, OnInit } from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Component({
  selector: 'app-grievance-redressal-system',
  templateUrl: './grievance-redressal-system.component.html',
  styleUrls: ['./grievance-redressal-system.component.scss']
})
export class GrievanceRedressalSystemComponent implements OnInit {

  constructor(private http:HttpClient) { }

  ngOnInit(): void {
  }
  onSubmit(data){
    debugger;
    this.http.post('http://localhost:54164/api/v1/Grievance/AddGrivancecomplaints',data)
    .subscribe((result)=>{
      console.warn("result",result);
    })
    console.log(data)
  }
}
